import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/base/Seo";
import PageHeader from "@/components/feature/PageHeader";
import ActionCard from "./components/ActionCard";
import CallToAction from "@/pages/home/components/CallToAction";
import { useCollection } from "@/hooks/useCollection";
import type { Action } from "@/lib/types";

const actionsHeroImage =
  "https://readdy.ai/api/search-image?query=Warm%20editorial%20wide%20photograph%20of%20humanitarian%20volunteers%20in%20red%20vests%20distributing%20food%20and%20supplies%20to%20families%20in%20an%20African%20village%20at%20golden%20hour%2C%20dynamic%20teamwork%20and%20solidarity%2C%20soft%20natural%20light%2C%20premium%20humanitarian%20campaign%20photography%2C%20high%20detail&width=1600&height=500&seq=humanity59-actions-hero&orientation=landscape&nocache=true";

export default function Actions() {
  const { items } = useCollection<Action>("actions");

  return (
    <div className="min-h-screen flex flex-col">
      <Seo
        title="Nos actions humanitaires | Humanity59"
        description="Aide alimentaire, maraudes, collectes, accompagnement : découvrez les actions humanitaires d'Humanity59 en Afrique et en Asie et agissez à nos côtés."
        keywords="actions humanitaires, aide alimentaire, maraudes, collectes, solidarité"
        path="/actions"
      />
      <Header />
      <main className="flex-1">
        <PageHeader
          title="Nos actions"
          subtitle="Aide alimentaire, maraudes, collectes, accompagnement : découvrez comment nous agissons concrètement sur le terrain."
          image={actionsHeroImage}
        />

        {items.length > 0 && (
          <section className="py-16 md:py-24 bg-background-50">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="text-center max-w-2xl mx-auto">
                <span className="inline-block text-sm font-semibold text-primary-600">
                  Six domaines d'action
                </span>
                <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                  Des actions concrètes, au plus près des besoins
                </h2>
                <p className="mt-4 text-base text-foreground-600 leading-relaxed">
                  Chaque action est menée par nos équipes avec un objectif
                  simple : redonner dignité et espoir aux plus démunis. Cliquez
                  sur une photo pour l'agrandir.
                </p>
              </div>

              <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8">
                {items.map((a) => (
                  <ActionCard
                    key={a.title}
                    action={{
                      id: a.id,
                      slug: a.slug,
                      title: a.title,
                      icon: a.icon,
                      description: a.description,
                      stat: { value: a.stat_value, label: a.stat_label },
                      gallery:
                        a.gallery && a.gallery.length > 0 ? a.gallery : [],
                      cagnotte_url: a.cagnotte_url ?? undefined,
                      cagnotte_goal: a.cagnotte_goal ?? null,
                      cagnotte_collected: a.cagnotte_collected ?? null,
                    }}
                  />
                ))}
              </div>
            </div>
          </section>
        )}

        <CallToAction />
      </main>
      <Footer />
    </div>
  );
}